<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row>

        <DeletePlace v-model="showDeletePlaceDialog"/>

        <NewEditPlace/>

        <v-col cols="12" class="d-flex justify-space-between align-center">
            <v-text-field :hint="$t('general.search')"
                          clearable
                          class="mr-3"
                          color="kbDarkBlue"
                          :placeholder="$t('general.search')"
                          v-model="search">
                <template v-slot:append-outer>
                    <v-icon color="kbDarkBlue" @click="getPlaces" class="ml-2">refresh</v-icon>
                </template>
            </v-text-field>

            <v-tooltip :disabled="companyBlocked" bottom>
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <v-btn :disabled="companyBlocked"
                               dark
                               @click="showCreatePlace"
                               color="kbPurple">
                            {{ $t('general.newPlace') }}
                        </v-btn>
                    </div>
                </template>
                <span>{{ companyBlocked ? $t('general.mustChargeBeforeCreatingPlaces') : $t('general.newPlace') }}</span>
            </v-tooltip>
        </v-col>

        <v-col class="text-h6" cols="12">
            <v-data-table class="elevation-2"
                          :headers="headers"
                          :items="places"
                          :loading="loadingPlaces"
                          :options.sync="optionsPlaces"
                          :footer-props="{
                            'items-per-page-text': `${$t('general.places')} ${$t('general.perPage')}`,
                            'items-per-page-options': [50, 100, 200]
                          }"
                          :server-items-length="totalPlaces">
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="text-align: center">
                      <v-avatar :color="item.active ? 'success' : 'error'"
                            size="10"
                            v-model="item.active"
                            />
                    </td>

                    <td class="font-weight-bold text-capitalize">{{ item.name || $t('general.noName') }}</td>
                    <td class="font-weight-bold text-capitalize">{{ item.type }}</td>
                    <td class="font-weight-bold text-capitalize">{{ item.city }}</td>
                    <td v-if="item.placeLocationUrl" class="font-weight-bold text-capitalize"><a :href="item.placeLocationUrl" target="_blank">{{ item.placeLocation }}</a></td>
                    <td v-else class="font-weight-bold text-capitalize">{{ item.placeLocation }}</td>
                    <td>{{ typeof item.phone === 'string' ? item.phone : item.phone.phone }}</td>

                    <td><a :href="item.website" target="_blank">{{ item.website }}</a></td>

                    <td class="ma-0 pa-0">
                      <div class="data-table-actions d-flex justify-center align-center">
                        <v-btn @click="showPlace(item)" color="kbDarkBlue" text icon>
                            <v-icon>remove_red_eye</v-icon>
                        </v-btn>

                        <v-menu>
                            <template v-slot:activator="{ on }">
                                <v-btn color="kbDarkBlue" text icon v-on="on">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item @click="showEditPlace(item)">
                                    <v-list-item-action>
                                        <v-icon color="kbDarkBlue">edit</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>{{ $t('general.editPlace') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="showDeletePlace(item)">
                                    <v-list-item-action>
                                        <v-icon color="kbDarkBlue">delete</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>{{ $t('general.deletePlace') }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                      </div>
                    </td>
                  </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" v-if="loadingPlaces" cols="12">
                            {{ $t('general.loadingPlaces') }}
                        </v-col>
                        <v-col class="red--text text-center" v-else cols="12">
                            {{ $t('general.noPlacesRegistered') }}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import DeletePlace from '@/pages/App/Events/dialogs/Places/DeletePlace'
import NewEditPlace from '@/pages/App/Events/dialogs/Places/NewEditPlace'

export default {
  components: {
    DeletePlace,
    NewEditPlace
  },
  computed: {
    ...mapState({
      selectedApp: state => state.apps.selectedApp,
      places: state => state.events.places,
      totalPlaces: state => state.events.totalPlaces,
      loadingPlaces: state => state.events.loadingPlaces
    }),

    ...mapGetters(['companyBlocked']),

    search: {
      get () {
        return this.$store.state.events.searchPlaces
      },
      set (value) {
        this.$store.commit('SET_SEARCH_PLACES', value)
      }
    },

    isSearching () {
      return this.search && this.search !== ''
    },

    optionsPlaces: {
      get () {
        return this.$store.state.events.optionsPlaces
      },
      set (value) {
        this.$store.commit('SET_PAGINATION_PLACES', value)
      }
    },

    showNewEditPlaceDialog: {
      get () {
        return this.$store.state.events.showNewEditPlaceDialog
      },
      set (value) {
        this.$store.commit('SET_SHOW_NEW_EDIT_PLACE_DIALOG', value)
      }
    },

    showSetPlacePhoto: {
      get () {
        return this.$store.state.events.showSetPlacePhoto
      },
      set (value) {
        this.$store.commit('SET_SHOW_SET_PLACE_PHOTO', value)
      }
    },
    headers () {
      return [
        { text: this.$t('general.active'), value: 'active' },
        { text: this.$t('general.name'), value: 'name' },
        { text: this.$t('general.type'), value: 'type' },
        { text: this.$t('general.city'), value: 'city' },
        { text: this.$t('general.placeLocation'), value: 'placeLocation' },
        { text: this.$t('general.phone'), value: 'phone' },
        { text: this.$t('general.webSiteUrl'), value: 'website' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: '' }
      ]
    }
  },
  created () {},
  data () {
    return {
      showDeletePlaceDialog: false
    }
  },
  methods: {
    getPlaceCategories () {
      this.$store.dispatch('getPlaceCategories')
    },
    getPlacePreferences () {
      this.$store.commit('SET_PAGINATION_PLACE_PREFERENCES', {
        page: 1,
        itemsPerPage: 100
      })
      this.$store.dispatch('getPlacePreferences')
      this.$store.commit('SET_PAGINATION_PLACE_PREFERENCES', {})
    },
    showCreatePlace () {
      this.$store.commit('SET_METHOD_CREATE_OR_UPDATE_PLACE', 'new')
      this.showNewEditPlaceDialog = true
    },
    getPlaces () {
      this.$store.dispatch('getPlaces')
    },

    showPlace (place) {
      this.$store.commit('SET_METHOD_CREATE_OR_UPDATE_PLACE', 'view')
      this.$store.commit('SET_NEW_EDIT_PLACE_OBJ', { ...place })
      this.showNewEditPlaceDialog = true
    },

    showEditPlace (place) {
      this.$store.commit('SET_METHOD_CREATE_OR_UPDATE_PLACE', 'edit')
      this.$store.commit('SET_NEW_EDIT_PLACE_OBJ', { ...place })
      this.showNewEditPlaceDialog = true
    },

    showDeletePlace (place) {
      this.$store.commit('SET_SELECTED_PLACE', place)
      this.showDeletePlaceDialog = true
    }
  },
  watch: {
    optionsPlaces: {
      handler () {
        this.getPlaces()
        this.getPlaceCategories()
        this.getPlacePreferences()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      console.log(this.search)
      this.optionsPlaces.page = 1

      this.getPlaces()
    },
    selectedApp () {
      this.getPlaces()
      this.getPlaceCategories()
      this.getPlacePreferences()
    }
  }
}
</script>
